/**
 * 当前活动会话（T06）。
 *
 * 路由骨架只提供固定的 `#/chat`（无路径参数），因此「打开哪一条会话」由本模块
 * 用 localStorage 记住：会话列表点「进入对话」时写入 id，对话页挂载时读取。
 * 选 localStorage 而不是内存变量的原因是验收要求「刷新后仍在」——刷新后
 * 依然能定位回同一条会话（消息本身在 IndexedDB 里）。
 */
const STORAGE_KEY = 'zxtalk.activeConversationId';

function storage(): Storage | undefined {
  try {
    return typeof globalThis.localStorage === 'undefined' ? undefined : globalThis.localStorage;
  } catch {
    return undefined;
  }
}

/** 读当前活动会话 id；未设置或已损坏时返回 null。 */
export function getActiveConversationId(): string | null {
  const raw = storage()?.getItem(STORAGE_KEY) ?? null;
  if (raw === null) return null;
  const trimmed = raw.trim();
  return trimmed === '' ? null : trimmed;
}

/** 写当前活动会话 id；传 null 表示清空。 */
export function setActiveConversationId(id: string | null): void {
  const store = storage();
  if (store === undefined) return;
  if (id === null) store.removeItem(STORAGE_KEY);
  else store.setItem(STORAGE_KEY, id);
}
